import { Button, Tooltip } from '@chakra-ui/react';
import { ReactComponent as CrownIcon } from 'assets/icons/crown_upgrade_fill.svg';
import { ReactComponent as NewTabIcon } from 'assets/icons/new_tab.svg';
import { ReactComponent as UploadIcon } from 'assets/icons/upload_cloud.svg';
import { Code } from 'constants/keyboard';
import { useTranslation } from 'react-i18next';

import { useDocumentFonts } from './DocumentFonts';
import { FONT_UPLOAD_BUTTON_ID, SELECT_MENU_SEARCH_ID } from './SelectList.config';

export const FontUploadButton = () => {
  const { t } = useTranslation('editor_toolbar');
  const { fontUploadProps } = useDocumentFonts();
  const { hasUploadPermission, onClick } = fontUploadProps;

  const onKeyDown = (e: React.KeyboardEvent) => {
    // Focus on the search input when tab is pressed if button is focused
    if (e.key === Code.Tab) {
      const fontSearchInputEl = document.getElementById(SELECT_MENU_SEARCH_ID);
      if (fontSearchInputEl) {
        e.preventDefault();
        fontSearchInputEl.focus();
      }
    }
    if (e.key === Code.Enter) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <Tooltip
      borderRadius='4px'
      hasArrow
      placement={'bottom'}
      label={<NewTabIcon />}
      bg='black'
      py={1}
      px={1}
      isDisabled={!hasUploadPermission}
    >
      <Button
        onKeyDown={onKeyDown}
        id={FONT_UPLOAD_BUTTON_ID}
        tabIndex={-1}
        as={hasUploadPermission ? 'a' : 'button'}
        w='100%'
        variant={hasUploadPermission ? 'action' : 'upgrade'}
        leftIcon={hasUploadPermission ? <UploadIcon width='20px' height='20px' color='white' /> : <CrownIcon />}
        size='sm'
        data-testid='font-family-upload-button'
        aria-label={t(hasUploadPermission ? 'fontFamily.uploadFonts' : 'fontFamily.upgradeToUploadFonts')}
        onClick={onClick}
        cursor='pointer'
      >
        {t(hasUploadPermission ? 'fontFamily.uploadFonts' : 'fontFamily.upgradeToUploadFonts')}
      </Button>
    </Tooltip>
  );
};
FontUploadButton.displayName = 'FontUploadButton';
